import './dashboard_query_view.js.coffee'
import '../survey_dashboard_charts_view.js.coffee'

class Monitoring.Views.DashboardSurveyView extends Monitoring.Views.DashboardQueryView
  template: JST['backbone/templates/surveys/dashboard_survey']

  initialize: (@options = {}) ->
    super(@options)

  render: ->
    super()
    @renderActions()
    @

  renderActions: ->
    @$el.find('#dashboard-actions-container').html(
      new Surveys.Views.Dashboard.ActionsView().render().el
    )

  createFilterView: (searchQuery, dashboardResults, _topics, _channels) ->
    new Monitoring.Views.SocialContents.Filters.SurveyFiltersView({
      searchQuery: searchQuery,
      facets: dashboardResults.facets,
      tagsByClientCode: dashboardResults.tags_by_client_code,
    })

  createChartsView: (searchQuery, dashboardResults, sessionSharingData) ->
    @setDefaultCharts(searchQuery, dashboardResults.facets)
    new Monitoring.Views.SurveyDashboardChartsView
      searchQuery: searchQuery
      facets: dashboardResults.facets
      eventList: dashboardResults.events
      totalCount: dashboardResults.total
      uniqueUsersCount: dashboardResults.unique_users
      tagsByClientCode: dashboardResults.tags_by_client_code
      taxonomiesCodes: dashboardResults.taxonomies_codes
      sessionSharingData: sessionSharingData

  setDefaultCharts: (searchQuery, facets) ->
    if searchQuery.get('charts').length == 0
      charts = [
        {class: 'SurveyResponsesTimeseriesView', name: 'SurveyResponses'},
        {class: 'SurveyRequestsTimeseriesView', name: 'SurveyRequests', avoid_preview: true}
      ]
      charts = charts.concat Monitoring.Views.SurveyDashboardChartsView.surveyCharts(facets.cem_surveys)
      searchQuery.set('charts', charts)

  _exportExcel: =>
    @_exportData('export_survey_excel',
      I18n.t('monitoring.dashboard.actions.export.error'),
      @$el.find('#results-count').text())
